import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { FluentCustomizations } from '@uifabric/fluent-theme';
import { Customizer, mergeStyles } from 'office-ui-fabric-react';

import AppRouter from './components/AppRouter';
import configureStore from './store';

// Inject some global styles
mergeStyles({
    selectors: {
        ':global(body), :global(html), :global(#root)': {
            margin: 0,
            padding: 0,
            height: '100vh'
        },
        ':global(body)': {
            overflow: 'hidden'
        }
    }
});

document.title = 'PARCELY-ONLINE';

ReactDOM.render(
    <Provider store={configureStore()}>
        <Customizer {...FluentCustomizations}>
            <AppRouter />
        </Customizer>
    </Provider>,
    document.getElementById('root')
);
